import React from 'react';

import http from 'api/http';
import { componentFamilyAPI } from 'api/requests';

import FilePicker from 'Components/FilePicker';
import Select from 'Components/Select';

export default class EditApplication extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      familyInfo: '',
      requestInProcess: false
    };
  }

  componentDidMount() {
    if (this.props.family) {
      this.getFamilyData();
    }
  }

  componentDidUpdate() {
    if ((this.props.family && !this.state.requestInProcess) && (!this.state.familyInfo || this.props.family.id !== this.state.familyInfo.id)) {
      this.getFamilyData();
    }
  }

  getFamilyData = () => {
    const {family} = this.props;
    this.setState({requestInProcess: true}, () => {
      http.get(componentFamilyAPI.info(family.id))
        .then(({data}) => {
          this.setState({familyInfo:data, requestInProcess: false})
        })
    })
  };

  render() {
    const {family, families, componentType, handleSelectFamily, familiesRequestInProcess} = this.props;
    const {familyInfo, requestInProcess} = this.state;

    return (
      <section className='scene_section'>
        <header>Family</header>
        <Select
          selectionList={families.filter(availableFamily => availableFamily.type.id === componentType.id)}
          type='primary'
          mainWrapperClassName='_margin_right_30'
          itemNameIndicator='name'
          label='Select existing family'
          placeholder='Select Component Family'
          defaultItem={family ? families.find(availableFamily => availableFamily.id === family.id) : {}}
          isLoading={familiesRequestInProcess}
          handleSelect={handleSelectFamily}
        />
        {family ? (
          requestInProcess ? (
            <div className='ect-spinner _width_pc_100 _height_100'>
              <div className='ect-spinner__image' />
            </div>
          ) : (
            <FilePicker
              isEditable={false}
              sectionHeaderClassName='scene_section-header _margin_top_20'
              notEditableStateSectionHeader='Uploaded Family documents'
              infoMessage='Test reports in this section are shared across the Component Family. Please edit Component Family to add / remove documents.'
              files={familyInfo.testReports}
              httpParams={{
                currentId: familyInfo.id,
                fileIdFieldName: 'id',
                currentMethod: componentFamilyAPI.downloadReport,
              }}
            />
          )
        ) : null}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/Application/New/FamilyInfo.jsx